export function getParameterByName (name, defaultVal) {
  const match = RegExp('[?&]' + name + '=([^&]*)').exec(decodeURIComponent(window.location.search ? window.location.search : window.location.href));
  const value = match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  if (value) {
    return value;
  }
  if (defaultVal) {
    return defaultVal;
  }
  return null;
}

export function mergeDeep (...objects) {
  const isObject = obj => obj && typeof obj === 'object';

  return objects.reduce((prev, obj) => {
    Object.keys(obj).forEach(key => {
      const pVal = prev[key];
      const oVal = obj[key];

      if (Array.isArray(pVal) && Array.isArray(oVal)) {
        prev[key] = pVal.concat(...oVal);
      } else if (isObject(pVal) && isObject(oVal)) {
        prev[key] = mergeDeep(pVal, oVal);
      } else {
        prev[key] = oVal;
      }
    });

    return prev;
  }, {});
}
